import React from 'react';

interface TransactionSlipProps {
  transaction: {
    id: string;
    type: 'payout' | 'credit' | 'debit';
    amount: number;
    status: string;
    date: string;
    recipient_name?: string;
    recipient_account?: string;
    recipient_ifsc?: string;
    recipient_upi?: string;
    bank_reference?: string;
    transaction_id?: string;
    merchant_reference?: string;
    merchant_name?: string;
    merchant_email?: string;
    description?: string;
    fee?: number;
    gst?: number;
    net_amount?: number;
  };
  merchantDetails?: {
    name: string;
    email: string;
    phone?: string;
    business_name?: string;
    address?: string;
  };
  onClose: () => void;
  onDownload: () => void;
}

const TransactionSlip: React.FC<TransactionSlipProps> = ({
  transaction,
  merchantDetails,
  onClose,
  onDownload,
}) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
    }).format(amount);
  };


  const getTransactionTypeLabel = (type: string) => {
    switch (type) {
      case 'payout':
        return 'Payout Transaction';
      case 'credit':
        return 'Credit Transaction';
      case 'debit':
        return 'Debit Transaction';
      default:
        return 'Transaction';
    }
  };

  const statusLower = transaction.status?.toLowerCase();
  const statusClass = statusLower === 'success' ? 'text-emerald-600 font-semibold' : statusLower === 'refunded' ? 'text-sky-600 font-semibold' : statusLower === 'failed' ? 'text-red-600 font-semibold' : 'text-amber-600 font-semibold';

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[10000] p-4 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-hidden flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-slate-200">
          <button type="button" onClick={onDownload} className="flex items-center gap-2 py-2.5 px-4 rounded-xl bg-violet-600 text-white text-sm font-semibold cursor-pointer hover:bg-violet-700">
            <span>📥</span> Download Slip
          </button>
          <button type="button" onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-lg border-none text-slate-500 hover:bg-slate-100 cursor-pointer text-xl">✕</button>
        </div>

        <div
          id="transaction-slip-content"
          className="p-5 overflow-y-auto flex-1 bg-slate-50"
          style={{ backgroundColor: '#ffffff', color: '#0f172a' }}
        >
          <div
            id="transaction-slip-card"
            className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm"
            style={{ backgroundColor: '#ffffff', color: '#0f172a' }}
          >
            <div className="text-center mb-5 pb-3 border-b border-slate-200">
              <div className="text-lg font-bold text-slate-800">Transaction Receipt</div>
              <div className="text-sm text-slate-500">Payment Confirmation</div>
            </div>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between py-2 border-b border-slate-100">
                <span className="text-slate-500">Merchant Ref:</span>
                <span className="font-mono text-slate-800">{transaction.merchant_reference || 'N/A'}</span>
              </div>
              <div className="flex justify-between py-2 border-b border-slate-100">
                <span className="text-slate-500">Date & Time:</span>
                <span className="text-slate-800">{formatDate(transaction.date)}</span>
              </div>
              <div className="flex justify-between py-2 border-b border-slate-100">
                <span className="text-slate-500">Beneficiary Name:</span>
                <span className="text-slate-800">{transaction.recipient_name || 'N/A'}</span>
              </div>
              <div className="flex justify-between py-2 border-b border-slate-100">
                <span className="text-slate-500">Account Number:</span>
                <span className="font-mono text-slate-800">{transaction.recipient_account || 'N/A'}</span>
              </div>
              <div className="flex justify-between py-2 border-b border-slate-100">
                <span className="text-slate-500">IFSC Code:</span>
                <span className="font-mono text-slate-800">{transaction.recipient_ifsc || 'N/A'}</span>
              </div>
              <div className="flex justify-between py-2 border-b border-slate-100">
                <span className="text-slate-500">Bank Reference Number:</span>
                <span className="font-mono text-slate-800">{transaction.bank_reference || 'N/A'}</span>
              </div>
              <div className="flex justify-between py-2 border-b border-slate-100">
                <span className="text-slate-500">Payment Mode:</span>
                <span className="text-slate-800">{transaction.recipient_upi ? 'UPI' : 'IMPS'}</span>
              </div>
              <div className="flex justify-between py-2 border-b border-slate-100">
                <span className="text-slate-500">Transfer Type:</span>
                <span className="text-slate-800">INSTANT</span>
              </div>
              <div className="flex justify-between py-2 border-b border-slate-100">
                <span className="text-slate-500">Status:</span>
                <span className={statusClass}>{transaction.status}</span>
              </div>
              <div className="flex justify-between py-3 pt-4">
                <span className="font-semibold text-slate-700">Transaction Amount:</span>
                <span className="font-bold text-lg text-slate-800">{formatCurrency(transaction.amount)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionSlip;



